import Vue from 'vue'
import { mapActivity, mapAlerts, mapAlert } from './helpers'
import { keyBy, isEmpty } from 'lodash'

const mutations = {
    /**
     *
     * @param {Object}  state vuex state
     * @param {Object}  payload
     * @param {String}   payload.tab
     */
    setActiveTab(state, { tab }) {
        Vue.set(state, 'activeTab', tab)
    },

    /**
     *
     * @param {Object}  state vuex state
     * @param {Object}  payload
     * @param {Array}   payload.dateRange
     */
    setSelectedTimeRange(state, { dateRange }) {
        Vue.set(state, 'selectedTimeRange', dateRange)
    },

    /**
     *
     * @param {Object}  state vuex state
     * @param {Object}  payload
     * @param {Array}   payload.data
     */
    setAllocationData(state, { data }) {
        Vue.set(state, 'allocationData', mapActivity(data))
    },

    /**
     *
     * @param {Object}  state vuex state
     * @param {Object}  payload
     * @param {String}  payload.timeUnit
     */
    setAllocationDataTimeUnit(state, { timeUnit }) {
        Vue.set(state, 'currentAllocationTimeUnit', timeUnit)
    },

    /**
     *
     * @param {Object}  state vuex state
     * @param {Object}  payload
     * @param {Array}   payload.allocations
     * @param {String}  payload.type
     */
    setAllocationTop(state, { allocations, type }) {
        Vue.set(state.allocationTop, type, keyBy(allocations, 'id'))
    },

    /**
     *
     * @param {Object}  state vuex state
     * @param {Object}  payload
     * @param {Number}  payload.id
     * @param {Array}   payload.data
     * @param {String}  payload.type
     */
    setAllocation(state, { id, data, timeUnit, type }) {
        Vue.set(state.allocationTop[type][id], 'allocations', mapActivity(data))
        Vue.set(state.allocationTop[type][id], 'timeUnit', timeUnit)
    },

    setAlerts(state, { alerts }) {
        Vue.set(state, 'alerts', mapAlerts(alerts))
    },

    /**
     *
     * @param {Object}  state vuex state
     * @param {Boolean} value
     */
    setAllocationTopLoading(state, value) {
        Vue.set(state.allocationTop, 'loading', value)
    },

    /**
     *
     * @param {Object}  state vuex state
     * @param {Object}  payload
     * @param {Number}  payload.id
     * @param {Boolean} payload.loading
     * @param {String}  payload.type
     */
    setLoadingAllocationBy(state, { id, loading, type }) {
        Vue.set(state.allocationTop[type][id], 'loading', loading)
    },

    /**
     *
     * @param {Object}  state vuex state
     * @param {Object}  payload
     * @param {Boolean}  payload.value
     */
    setDisplayAlertForm(state, { value }) {
        Vue.set(state, 'displayAlertForm', value)
    },

    /**
     *
     * @param {Object}  state vuex state
     * @param {Boolean} value
     */
    setAlertsLoading(state, value) {
        Vue.set(state, 'alertsLoading', value)
    },

    /**
     *
     * @param {Object}  state vuex state
     * @param {Object}  payload
     * @param {Array}   payload.data
     */
    setKibanaData(state, { data }) {
        Vue.set(state, 'kibanaData', data)
    },

    /**
     * @param {Object} alert alert to add
     */
    setNewAlert(state, { alert }) {
        Vue.set(state.alerts, alert.id, mapAlert(alert))
    },

    /**
     * @param {Object} alert alert to set in edition
     */
    setDeletedAlert(state, { alertId }) {
        Vue.delete(state.alerts, alertId)
    },

    /**
     * @param {Object} alert alert to set in edition
     */
    setAlertInEdition(state, { alert }) {
        if (isEmpty(alert)) Vue.set(state, 'alertInEdition', { ...alert })
        else {
            const objectType = alert.objectType === 'cs' ? 'segments' : alert.objectType
            Vue.set(state, 'alertInEdition', { ...alert, objectType })
        }
    },

    /**
     * @param {Object|null} payload alert to set in edition
     * @param {Number} alert.objectId
     * @param {String} alert.objectType 'segment' or 'audience'
     */
    setAlertInCreation(state, payload) {
        Vue.set(state, 'alertInCreation', payload)
    },

    /**
     * @param {Object} alert alert to set once edited
     */
    setAlert(state, { alert }) {
        alert.last_event = state.alerts[alert.id]?.lastEvent
        Vue.set(state.alerts, alert.id, mapAlert(alert))
    }
}

export default mutations
